"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.trim");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  form: '[js-search-bar="form"]',
  input: '[js-search-bar="input"]',
  label: '[js-search-bar="label"]',
  bcSearch: '.bc-sf-search-suggestion-mobile'
};
/**
 * Create a new search bar object.
 */

var _default = function _default() {
  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    form: document.querySelectorAll(selectors.form),
    input: document.querySelectorAll(selectors.input),
    bcSearch: document.querySelectorAll(selectors.bcSearch)
  };
  /**
   * Instance defaults.
   */

  var placeholder = document.querySelector(selectors.label).innerText.trim();
  /**
   * Initialise component.
   */

  function init() {
    setKeypressEvents();
    handleOnload();
    setFocusEvents();
    setEventListeners();
  }
  /**
   * Set keypress events on search input to hide label.
   */


  function setKeypressEvents() {
    _toConsumableArray(nodeSelectors.input).forEach(function (element) {
      (0, _utils.on)('keydown', element, function (event) {
        return handleKeypressEvent(event);
      });
    });
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    Frame.EventBus.listen(['Toggle:searchTarget:close', 'Toggle:searchTarget:open', 'Toggle:menuDrawerTarget:open', 'Toggle:cartDrawerTarget:open'], function () {
      return closeAutoSuggest();
    });
  }

  function closeAutoSuggest() {
    document.querySelectorAll(selectors.bcSearch).forEach(function (element) {
      element.style.display = 'none';
    });
  }
  /**
   * Set placeholder value on load.
   */


  function handleOnload() {
    _toConsumableArray(nodeSelectors.input).forEach(function (element) {
      if (element.value.length !== 0) {
        (0, _utils.getSiblings)(element)[0].classList.add(_cssClasses["default"].hidden);
      }
    });
  }
  /**
  * Set focus events on search input to reset placeholder value.
  */


  function setFocusEvents() {
    _toConsumableArray(nodeSelectors.input).forEach(function (element) {
      (0, _utils.on)('blur', element, function (event) {
        return handleFocusEvent(event);
      });
    });
  }
  /**
   * Handle search focus event.
   * @param {Event} event - blur event on search input.
   */


  function handleFocusEvent(event) {
    var target = event.target;

    if (target.value.length === 0) {
      (0, _utils.getSiblings)(target)[0].value = placeholder;
      (0, _utils.getSiblings)(target)[0].classList.remove(_cssClasses["default"].hidden);
    }
  }
  /**
   * Handle search keydown event.
   * @param {Event} event - keydown event on search input.
   */


  function handleKeypressEvent(event) {
    var target = event.target;

    if (target.value.length >= 0) {
      (0, _utils.getSiblings)(target)[0].classList.add(_cssClasses["default"].hidden);
      return;
    }

    (0, _utils.getSiblings)(target)[0].classList.remove(_cssClasses["default"].hidden);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;